module.exports = __webpack_public_path__ + "img/logo_blanco_2.220276ea.png";